module.exports = __webpack_public_path__ + "img/O7.e5066c92.png";